import React from "react";
import { Box, Typography, Button } from "@mui/material";
import BackgroundPaws from "../../assets/images/services/backgroundPaws.png";
import Underline from "../../assets/images/services/underline.png";
import ServicesCard from "./ServicesCard";
import washAndDry from "../../assets/images/services/washanddry.jpeg";
import BathandBrush from "../../assets/images/services/bathandbrush.jpeg";
import FullDogGroom from "../../assets/images/services/fulldoggroom.jpeg";
import TidyUp from "../../assets/images/services/tidyup.jpeg";
import DeMatting from "../../assets/images/services/dematting.jpeg";
import Brushing from "../../assets/images/services/brushing.jpeg";
import NailClipping from "../../assets/images/services/nailclipping.jpeg";
import EarCleaning from "../../assets/images/services/earcleaning.jpeg";

import DogWalking from "../../assets/images/services/DogWalking.jpg";
import DogPregnancyScanning from "../../assets/images/services/DogPregnancyScanning.jpg";
import DogMicrochipping from "../../assets/images/services/DogMicrochipping.jpg";

import Booknow from "../../assets/images/booknow.svg";
import { useNavigate } from "react-router-dom";

export default function Services() {
  const navigate = useNavigate();
  return (
    <Box sx={{ overflow: "hidden" }}>
      <Box
        sx={{
          position: "relative",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          flexDirection: "column",
          height: { lg: "calc(100vh - 160px)", xs: "calc(100dvh - 330px)" },
          padding: "20px",
          marginTop: { lg: "120px", xs: "290px" },
          overflow: "auto",

          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url(${BackgroundPaws}), url(${BackgroundPaws})`,
            backgroundRepeat: "no-repeat, no-repeat",
            backgroundPosition: "top right, -200px 580px",
            backgroundSize: "auto 30%, auto 30%",
            opacity: 0.4,
            zIndex: -1,
          },
        }}
      >
        {/* Title with custom underline */}
        <Box
          sx={{
            position: "fixed",
            top: { lg: "45px", xs: "205px" },
            display: "inline-block",
            textAlign: "center",
            paddingBottom: "10px",
            "&::after": {
              content: '""',
              position: "absolute",
              bottom: 0,
              left: "50%",
              transform: "translateX(-50%)",
              height: "20px",
              width: "100%",
              backgroundImage: `url(${Underline})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "contain",
            },
          }}
        >
          <Typography
            sx={{
              color: "#F04336",
              fontSize: { lg: "40px", xs: "30px" },
              fontFamily: "Nunito",
              fontWeight: 1000,
            }}
          >
            Services We Offer
          </Typography>
        </Box>
        {/* Services Cards */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-start",
            justifyContent: "center",
            flexWrap: "wrap",
            marginTop: "50px",
            gap: "40px",
          }}
        >
          <ServicesCard
            img={washAndDry}
            imgAlt="washAndDry"
            title="Wash and Blow Dry"
          />
          <ServicesCard
            img={BathandBrush}
            imgAlt="Bath, Brush and Blow Dry"
            title="Bath, Brush and Blow Dry"
          />
          <ServicesCard
            img={FullDogGroom}
            imgAlt="Full Dog Grooming"
            title="Full Dog Groom: Wash/Dry/Style"
          />
          <ServicesCard img={TidyUp} imgAlt="Tidy Up" title="Tidy Up" />
          <ServicesCard
            img={DeMatting}
            imgAlt="De-Matting"
            title="De-Matting"
          />
          <ServicesCard
            img={Brushing}
            imgAlt="Brushing"
            title="Tooth Brushing"
          />
          <ServicesCard
            img={NailClipping}
            imgAlt="Nail Clipping"
            title="Nail Clipping"
          />
          <ServicesCard
            img={EarCleaning}
            imgAlt="Ear Cleaning"
            title="Ear Cleaning"
          />
          <ServicesCard
            img={DogWalking}
            imgAlt="Dog Walking"
            title="Dog Walking"
          />
          <ServicesCard
            img={DogPregnancyScanning}
            imgAlt="Dog Pregnancy Scanning"
            title="Dog Pregnancy Scanning"
          />
          <ServicesCard
            img={DogMicrochipping}
            imgAlt="Dog Microchipping"
            title="Dog Microchipping"
          />
        </Box>
        {/* Book Now Details */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "50px",
            backgroundColor: "#F04336",
            padding: "20px 60px",
            borderRadius: "20px",
            textAlign: "center",
            gap: "20px",
          }}
        >
          <Typography
            sx={{
              color: "white",
              fontSize: { lg: "40px", xs: "30px" },
              fontFamily: "Nunito",
              fontWeight: 800,
            }}
          >
            Feel free to let me know if there's anything else you need
          </Typography>
          <Typography
            sx={{
              color: "white",
              fontSize: { lg: "40px", xs: "30px" },
              fontFamily: "Nunito",
              fontWeight: 800,
            }}
          >
            I'd be delighted to assist!{" "}
          </Typography>
          <Box
            onClick={() => navigate("../contactme")}
            sx={{ cursor: "pointer" }}
          >
            <img
              style={{
                height: "auto",
                marginTop: "15px",
              }}
              src={Booknow}
              alt="Booknow"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
